import api from "!../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../node_modules/css-loader/dist/cjs.js??clonedRuleSet-8.use[1]!../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-8.use[2]!./input.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};